import { shallowEqual, useSelector } from "react-redux";
import { SESSION_KINDS } from "../../../../../util/constants";
import { sortSessions, splitYearIntoSections } from "../../functions";
import { selectSessionInformation } from "../../../../util/selectors";
import { createSelector } from "@reduxjs/toolkit";
import { useGetSessionSchemaQuery } from "../../../../../services/submissionPeriod/api";

export const selectSessionsWithDrafts = createSelector(
  [
    (state, type, year, count) => selectSessionInformation(state, type, year),
    (state, type, year, count) => type,
    (state, type, year, count) => year,
    (state, type, year, count = 2) => count,
  ],
  (realSessions, type, year, count) => {
    const drafts = splitYearIntoSections(year, count, {
      calendarType: type,
      isDraft: true
    });
    const filtered = drafts.filter((draft) =>
      !realSessions.some(({ year: sessionYear, period }) => {
        const match = (
          `${sessionYear}` === `${draft.year}` &&
          period &&
          `${period}` === `${draft.period}`
        );
        return match
      })
    );

    return sortSessions([...realSessions, ...filtered]);
  }
);

const useSessions = ({ year, type = SESSION_KINDS.FGC, count = 2 }) => {
  const {
    data = {},
  } = useGetSessionSchemaQuery({
    type,
  });
  const numberOfPeriods = data?.numberOfPeriods || count
  const sessions = useSelector(
    (state) => selectSessionsWithDrafts(state, type, year, numberOfPeriods),
    shallowEqual
  );

  return { sessions, isLoading: false };
};

export default useSessions;
